import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import React, { useState, useEffect } from 'react';

import { CFGScaleInput } from './CFGScaleInput';
import { ImageCropModal } from './ImageCropModal';
import { ImageGuidance } from './ImageGuidance';
import { ModelSelect } from './ModelSelect';
import { PreviewList } from './PreviewList';
import { PromptInput } from './PromptInput';
import { StyleReferenceBar } from './StyleReferenceBar';
import { Title } from './TitleTip';
import { track } from '../../track';

const InpaintModal = dynamic(
  () => import('../Image/Inpaint').then(({ InpaintModal }) => InpaintModal),
  { ssr: false }
);

const PAGE = 'image_generation_page';

export interface ImageCreationLayoutProps {
  header: React.ReactNode;
  styles: Record<string, string>;
  cdnPrefix: string;
}

export function ImageCreationLayout({ header, styles, cdnPrefix }: ImageCreationLayoutProps) {
  const [isShowStyleReferenceBar, setIsShowStyleReferenceBar] = useState(false);
  const [isShowImageCropModal, setIsShowImageCropModal] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // 页面曝光埋点
    track.send('page_view', PAGE);
  }, []);

  return (
    <div className={styles.wrapper}>
      {/* Header */}
      {header}
      <div className={styles.body}>
        {/* 图片参数 */}
        <div className={styles.left}>
          <div className={styles.content}>
            <div className={styles.metaArea}>
              <Title title={t('model_selection')} styles={styles} />
              <ModelSelect source={PAGE} />
              <div className={styles.divider} />
              <Title title={t('image_guidance')} styles={styles} />
              <ImageGuidance
                source={PAGE}
                cdnPrefix={cdnPrefix}
                onShowStyleReferenceBar={() => setIsShowStyleReferenceBar(true)}
                onShowImageCropModal={() => setIsShowImageCropModal(true)}
              />
              <div className={styles.divider} />
              <Title title={t('cfg_scale')} desc={t('cfg_scale_tip')} styles={styles} />
              <CFGScaleInput source={PAGE} />
            </div>
          </div>
          <StyleReferenceBar
            isShow={isShowStyleReferenceBar}
            setIsShow={setIsShowStyleReferenceBar}
            cdnPrefix={cdnPrefix}
            source={PAGE}
          />
          <ImageCropModal
            show={isShowImageCropModal}
            setShow={setIsShowImageCropModal}
            cdnPrefix={cdnPrefix}
            source={PAGE}
          />
        </div>
        {/* prompt 输入和图片预览 */}
        <div className={styles.rightWrapper}>
          <div className={styles.right}>
            <PromptInput source={PAGE} />
            <div className={styles.previewList}></div>
            <PreviewList source={PAGE} />
            <InpaintModal />
          </div>
        </div>
      </div>
    </div>
  );
}
